import React, { useState, useEffect } from "react";
import axios from "axios";
import { Spin, Modal, Button } from "antd";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

  const API_BASE = process.env.REACT_APP_API_BASE;

function Blind() {
  const [services, setServices] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBlind, setSelectedBlind] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  // Fetch all services from backend
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(`${API_BASE}/service/readAllService`);
        const data = res?.data?.data?.services || [];

        // Filter only those services where category === "Blind"
        const blindServices = data.filter(
          (item) =>
            item.category?.toLowerCase() === "blind" ||
            item.category?.toLowerCase() === "blinds"
        );

        setServices(blindServices);
        setFiltered(blindServices);
      } catch (error) {
        console.error("Error fetching blinds:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <div className="max-w-7xl mx-auto mt-10 mb-16 px-4">
      <h2
        className="text-3xl md:text-4xl font-bold text-center mb-10"
        style={{ color: "#1A8F5A", fontFamily: "var(--font-heading)" }}
      >
        Blinds Collection
      </h2>

      {loading ? (
        <div className="flex justify-center items-center py-16">
          <Spin size="large" />
        </div>
      ) : filtered.length === 0 ? (
        <p className="text-center text-gray-500">No blinds available.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {filtered.map((blind, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              viewport={{ once: true }}
              className="rounded-xl overflow-hidden border cursor-pointer"
              style={{
                background: "#FFFFFF",
                border: "1px solid #E5E7EB",
                boxShadow: "0 8px 20px rgba(18,24,30,0.04)",
              }}
            >
              <img
                src={blind.image || "https://source.unsplash.com/400x300/?window,interior"}
                alt={blind.name}
                className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                onClick={() => {
                  setSelectedBlind(blind);
                  setIsModalOpen(true);
                }}
              />

              <div className="p-4">
                <h3
                  className="text-lg font-semibold line-clamp-1"
                  style={{ color: "#1A1A1A", fontFamily: "var(--font-heading)" }}
                >
                  {blind.name}
                </h3>

                <p className="text-sm text-gray-500 line-clamp-2">
                  {blind.description}
                </p>

                <p
                  className="font-semibold mt-2"
                  style={{ color: "#1A8F5A" }}
                >
                  {blind.price ? `£${blind.price}` : "Price on request"}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      )}

      {/* Image Modal */}
      <Modal
        title={selectedBlind?.name}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
        width={600}
      >
        <div className="space-y-4">
          <img
            src={selectedBlind?.image || "https://source.unsplash.com/400x300/?window,interior"}
            alt={selectedBlind?.name}
            className="w-full h-80 object-cover rounded-lg"
          />
          <div>
            <p className="text-gray-600 mb-2">{selectedBlind?.description}</p>
            <p className="font-semibold text-xl" style={{ color: "#1A8F5A" }}>
              {selectedBlind?.price ? `£${selectedBlind.price}` : "Price on request"}
            </p>
          </div>
          <Button
            type="primary"
            size="large"
            onClick={() => {
              setIsModalOpen(false);
              navigate("/FilteredBook");
            }}
            style={{ backgroundColor: "#1A8F5A", width: "100%" }}
          >
            Select the Provider
          </Button>
        </div>
      </Modal>
    </div>
  );
}

export default Blind;
